module.exports = __webpack_public_path__ + "img/Palette-Puroak-EN.asset.3faeaf98.svg";